//middleware
import { Route } from "react-router-dom";

//views
import { ROUTES } from "../utils/routes";
import { ManageProject } from "../views/Logged/Projects/ManageProjects/ManageProject";
import { Projects } from "../views/Logged/Projects/Projects";
import { Patents } from "../views/Logged/Patents/Patents";
import { ManagePatents } from "../views/Logged/Patents/ManagePatents/ManagePatents";
import { Offers } from "../views/Logged/Offers/Offers";
import { ManageOffer } from "../views/Logged/Offers/ManageOffer/ManageOffer";
import { Announcements } from "../views/Logged/Announcements/Announcements";
import { ManageAnnouncements } from "../views/Logged/Announcements/ManageAnnouncements/ManageAnnouncements";
import { Sliders } from "../views/Logged/Sliders/Sliders";
import { ManageSliders } from "../views/Logged/Sliders/ManageSliders/ManageSliders";
import { Resources } from "../views/Logged/Resources/Resources";
import { ManageResource } from "../views/Logged/Resources/ManageResources/ManageResource";
import { Users } from "../views/Logged/Users/Users";
import { ManageProfile } from "../views/Logged/ManageProfile/ManageProfile";
import { News } from "../views/Logged/News/News";
import { ManageNews } from "../views/Logged/News/ManageNews/ManageNews";
import { ResearchTesis } from "../views/Logged/Thesis/Tesis";
import { ManageTesis } from "../views/Logged/Thesis/ManageTesis/ManageTesis";
import { Seminars } from "../views/Logged/Seminars/Seminars";
import { ManageSeminars } from "../views/Logged/Seminars/ManageSeminars/ManageSeminars";
import { EntidadParticipante } from "../views/Logged/EntidadParticipante/EntidadParticipante";
import { ManageEntidadParticipante } from "../views/Logged/EntidadParticipante/ManageEntidadParticipante/ManageEntidadParticipante";
import { ManageEntidadFinanciadora } from "../views/Logged/EntidadFinanciadora/ManageEntidadFinanciadora/ManageEntidadFinanciadora";
import { EntidadFinanciadora } from "../views/Logged/EntidadFinanciadora/EntidadFinanciadora";
import { Convocatorias } from "../views/Logged/Convocatoria/Convocatorias";
import { ManageConvocatoria } from "../views/Logged/Convocatoria/ManageConvocatoria/ManageConvocatoria";
import { Propuestas } from "../views/Logged/Propuestas/Propuestas";
import { ManagePropuesta } from "../views/Logged/Propuestas/ManagePropuestas/ManagePropuesta";
import { SerieLibros } from "../views/Logged/SerieLibros/SerieLibros";
import { ManageSerieLibros } from "../views/Logged/SerieLibros/ManageSerieLibro/ManageSerieLibro";
import { Revistas } from "../views/Logged/Revistas/Revistas";
import { ManageRevistas } from "../views/Logged/Revistas/ManageRevistas/ManageRevistas";
import { Biblioteca } from "../views/Logged/Biblioteca/Biblioteca";
import { ManageLibros } from "../views/Logged/Libros/ManageBiblioteca/ManageLibros";
import { ManageEjemplares } from "../views/Logged/Ejemplares/ManageBiblioteca/ManageEjemplares";
import { InvestigadoresInvitados } from "../views/Logged/InvestigadoresInvitados/InvestigadoresInvitados";
import { ManageIngestigadorInvitado } from "../views/Logged/InvestigadoresInvitados/ManageInvestigadoresInvitados/ManageInvestigadoresInvitados";



const Admin_Gestion = () => {
  // prettier-ignore
  return (
    <>
      <Route exact path={ROUTES.Users.all} component={Users} />
      <Route
        exact
        path={[ROUTES.Users.create, ROUTES.Users.update]}
        component={ManageProfile}
      />
      <Route exact path={ROUTES.Tesis.all} component={ResearchTesis} />
      <Route
        exact
        path={[ROUTES.Tesis.create, ROUTES.Tesis.update]}
        component={ManageTesis}
      />
      <Route exact path={ROUTES.Seminars.all} component={Seminars} />
      <Route
        exact
        path={[ROUTES.Seminars.create, ROUTES.Seminars.update]}
        component={ManageSeminars}
      />
      <Route exact path={ROUTES.Patents.all} component={Patents} />
      <Route
        exact
        path={[ROUTES.Patents.create, ROUTES.Patents.update]}
        component={ManagePatents}
      />
      <Route exact path={ROUTES.Offers.all} component={Offers} />
      <Route
        exact
        path={[ROUTES.Offers.create, ROUTES.Offers.update]}
        component={ManageOffer}
      />
      <Route exact path={ROUTES.Announcements.all} component={Announcements} />
      <Route
        exact
        path={[ROUTES.Announcements.create, ROUTES.Announcements.update]}
        component={ManageAnnouncements}
      />
      <Route exact path={ROUTES.Sliders.all} component={Sliders} />
      <Route
        exact
        path={[ROUTES.Sliders.create, ROUTES.Sliders.update]}
        component={ManageSliders}
      />
      <Route exact path={ROUTES.Resource.all} component={Resources} />
      <Route
        exact
        path={[ROUTES.Resource.create, ROUTES.Resource.update]}
        component={ManageResource}
      />
      <Route exact path={ROUTES.Propuestas.all} component={Propuestas} />
      <Route
        exact
        path={[ROUTES.Propuestas.create, ROUTES.Propuestas.update]}
        component={ManagePropuesta}
      />
      <Route exact path={ROUTES.Projects.all} component={Projects} />
      <Route
        exact
        path={[ROUTES.Projects.create, ROUTES.Projects.update]}
        component={ManageProject}
      />
      <Route exact path={ROUTES.News.all} component={News} />
      <Route
        exact
        path={[ROUTES.News.create, ROUTES.News.update]}
        component={ManageNews}
      />
      <Route
        exact
        path={ROUTES.EntidadesParticipantes.all}
        component={EntidadParticipante}
      />
      <Route
        exact
        path={[
          ROUTES.EntidadesParticipantes.create,
          ROUTES.EntidadesParticipantes.update,
        ]}
        component={ManageEntidadParticipante}
      />
      <Route
        exact
        path={ROUTES.EntidadesFinanciadoras.all}
        component={EntidadFinanciadora}
      />
      <Route
        exact
        path={[
          ROUTES.EntidadesFinanciadoras.create,
          ROUTES.EntidadesFinanciadoras.update,
        ]}
        component={ManageEntidadFinanciadora}
      />
      <Route exact path={ROUTES.Convocatorias.all} component={Convocatorias} />
      <Route
        exact
        path={[ROUTES.Convocatorias.create, ROUTES.Convocatorias.update]}
        component={ManageConvocatoria}
      />
      <Route exact path={ROUTES.SerieLibros.all} component={SerieLibros} />
      <Route
        exact
        path={[ROUTES.SerieLibros.create, ROUTES.SerieLibros.update]}
        component={ManageSerieLibros}
      />
      <Route exact path={ROUTES.SerieLibros.all} component={SerieLibros} />
      <Route
        exact
        path={[ROUTES.SerieLibros.create, ROUTES.SerieLibros.update]}
        component={ManageSerieLibros}
      />

      <Route exact path={ROUTES.Revistas.all} component={Revistas} />
      <Route
        exact
        path={[ROUTES.Revistas.create, ROUTES.Revistas.update]}
        component={ManageRevistas}
      />

      <Route exact path={ROUTES.Biblioteca.all} component={Biblioteca} />
      <Route
        exact
        path={[ROUTES.Libros.create, ROUTES.Libros.update]}
        component={ManageLibros}
      />
      <Route
        exact
        path={[ROUTES.Ejemplares.create, ROUTES.Ejemplares.update]}
        component={ManageEjemplares}
      />
        <Route exact path={ROUTES.InvestigadoresInvitados.all} component={InvestigadoresInvitados} />
      <Route
        exact
        path={[ROUTES.InvestigadoresInvitados.create, ROUTES.InvestigadoresInvitados.update]}
        component={ManageIngestigadorInvitado}
      />
    </>
  );
};

export default Admin_Gestion;
